import {useParams} from 'react-router-dom';
import {
    Alert,
    Grid,
} from '@mantine/core';
import {AiOutlineWarning} from 'react-icons/ai';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile';
import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useTestRun} from '../hooks/useTestRun.ts';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';

// Deliberately DetailPage, not EditPage (FNP-969). The sibling modules name this
// EditPage because it toggles between a Profile and a RecordForm; there is no
// form here and no view/edit mode, because a TestRun cannot be edited by anyone
// — its three mutations are @aws_iam. Naming it EditPage would invite someone to
// add the missing half.
export const DetailPage = () => {

    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const {
        record,
        loading,
        isError,
    } = useTestRun(id);

    // Error before loading: a failed fetch otherwise sits on the spinner forever
    // and reads as a slow load rather than a broken one.
    if (isError) {
        return (
            <Alert
                icon={<AiOutlineWarning/>}
                color='red'
                title='Could not load this test run'
            >
                The Testing API did not respond, or no run exists with this id.
            </Alert>
        );
    }

    if (loading) {
        return <PlatformLoader message='Loading test run...Please wait'/>;
    }

    if (!record) {
        return (
            <Alert
                icon={<AiOutlineWarning/>}
                color='yellow'
                title='Test run not found'
            >
                No test run exists with this id.
            </Alert>
        );
    }

    return (
        <FormPageLayout
            title={record.testCode ?? record.id}
            pageNavigation={<EditPageNavigation component={record}/>}
            tools={[<ReloadRecordsButton key='reload'/>]}
        >
            <Grid>
                <Grid.Col span={{
                    base: 12,
                    lg: 6
                }}>
                    <Profile record={record}/>
                </Grid.Col>
            </Grid>
        </FormPageLayout>
    );
};
